import React from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { Description as DescriptionIcon } from '@mui/icons-material';
import { RTL } from '../../../cache/CacheRtl';

/**
 * DescriptionSection - the exercise description's CANONICAL (Hebrew) text.
 *
 * The English twin was removed when the translation panel landed (see BasicInfoSection): the
 * schema-driven panel already renders `description` for every non-canonical locale, so keeping an
 * English field here would mean two editors writing the same text to two different stores — the
 * legacy `exercises.description` column vs. an `entity_translation` row at locale `en` — and the
 * mobile read path resolves from the latter. `description` stays in the form's state and is passed
 * through unchanged on save so the legacy column is not rewritten; Phase 3 drops it.
 */
const DescriptionSection = ({
    formValues,
    setFieldValue,
    setFieldTouched,
    errors,
    touched
}) => {
    const inputStyles = {
        '& .MuiOutlinedInput-root': {
            backgroundColor: '#FFFFFF',
            borderRadius: '8px',
            '& fieldset': {
                borderColor: '#E2E8F0'
            },
            '&:hover fieldset': {
                borderColor: '#CBD5E1'
            },
            '&.Mui-focused fieldset': {
                borderColor: '#57837E'
            },
            '&.Mui-error fieldset': {
                borderColor: '#EF4444'
            }
        }
    };

    const maxLength = 1000;

    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                <DescriptionIcon sx={{ color: '#64748B', fontSize: '20px' }} />
                <Typography
                    sx={{
                        fontWeight: 600,
                        fontSize: '16px',
                        color: '#1E293B',
                        fontFamily: '"Heebo", "Roboto", sans-serif'
                    }}
                >
                    תיאור התרגיל
                </Typography>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <RTL>
                        <TextField
                            fullWidth
                            multiline
                            rows={4}
                            label="תיאור (עברית)"
                            value={formValues.descriptionHeb || ''}
                            onChange={(e) => setFieldValue('descriptionHeb', e.target.value)}
                            onBlur={() => setFieldTouched('descriptionHeb')}
                            error={touched.descriptionHeb && Boolean(errors.descriptionHeb)}
                            helperText={
                                (touched.descriptionHeb && errors.descriptionHeb) ||
                                `${formValues.descriptionHeb?.length || 0}/${maxLength}`
                            }
                            inputProps={{ maxLength }}
                            sx={inputStyles}
                        />
                    </RTL>
                </Grid>
            </Grid>
        </Box>
    );
};

export default DescriptionSection;
